"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputAxisHighestMagnitude = void 0;
const KHInputAxisDerived_1 = require("./KHInputAxisDerived");
/**
 * An axis that combines multiple axes and responds with the highest one.
 */
class KHInputAxisHighestMagnitude extends KHInputAxisDerived_1.KHInputAxisDerived {
    constructor(inputSet, sources) {
        super(inputSet);
        this.sources = sources;
    }
    updateDerivedInput(now, delta) {
        let highestMagnitude = 0;
        let highestMagnitudeValue = 0;
        this.sources.forEach((element) => {
            const value = element.getValue();
            let absValue = Math.abs(value);
            if (absValue > highestMagnitude) {
                highestMagnitude = absValue;
                highestMagnitudeValue = value;
            }
        });
        this.update(highestMagnitudeValue);
    }
}
exports.KHInputAxisHighestMagnitude = KHInputAxisHighestMagnitude;
